import React, { useEffect, useState } from "react";

import { getShapefileRegions, useCancelAsyncOnUnmount } from "utils";

import { Col, Input, InputNumber, Option, Row, Select } from "components";

export const FundingInputs = ({ fundingOpportunity, methods }) => {
  const [regionEnums, setRegionEnums] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  useEffect(() => {
    getShapefileRegions({ signal }).then((regionEnums) => {
      setRegionEnums(regionEnums);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Row>
        <Col sm={24} md={12}>
          <Input name="title" label="Title" rules={[{ required: true }]} initialValue={fundingOpportunity ? fundingOpportunity.title : ""} />
        </Col>
        <Col sm={24} md={6}>
          <InputNumber
            initialValue={fundingOpportunity ? fundingOpportunity.fundingAmount : 0}
            name="fundingAmount"
            label="Funding amount (€ / ha)"
            rules={[{ required: true }]}
            step={0.01}
            min={0}
          />
        </Col>
        <Col sm={24} md={6}>
          <Select name="active" label="Enabled" rules={[{ required: true }]} initialValue={fundingOpportunity && fundingOpportunity.active}>
            <Option key={1} value={true}>
              Enabled
            </Option>
            <Option key={2} value={false}>
              Disabled
            </Option>
          </Select>
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={12}>
          <Input name="link" label="Link / URL" rules={[{ required: true }]} initialValue={fundingOpportunity && fundingOpportunity.link} />
        </Col>
        <Col sm={24} md={12}>
          <Input
            initialValue={fundingOpportunity ? fundingOpportunity.linkText : "Besuche die Website deines Bundeslandes hier für weitere Informationen"}
            name="linkText"
            label="Name for your link / URL"
            rules={[{ required: false }]}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={24} md={12}>
          <Select name="regions" label="Regions" mode="multiple" rules={[{ required: true }]} initialValue={fundingOpportunity && fundingOpportunity.regions}>
            {Object.keys(regionEnums).map((item, i) => (
              <Option value={regionEnums[item]} key={i}>
                {regionEnums[item]}
              </Option>
            ))}
          </Select>
        </Col>
        <Col sm={24} md={12}>
          <Select
            name="methods"
            label="Methods this funding applies to"
            mode="multiple"
            rules={[{ required: true }]}
            initialValue={fundingOpportunity && fundingOpportunity.methods}
          >
            {methods.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    </>
  );
};
